import React from 'react';

import { flagStyles } from '../settings';

const SvgNE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3840px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNE;
